import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached initial consent data
export function useInitialConsentsSWRKey(country?: string, language?: string): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/consents/initial"

      return {
        url,
        params: {
          country,
          language,
        },
      }
    },
    [
      country,
      language,
    ],
  )

  return swrKey
}
